import { render, staticRenderFns } from "./couponSettingdet.vue?vue&type=template&id=cae4812a&scoped=true&"
import script from "./couponSettingdet.vue?vue&type=script&lang=js&"
export * from "./couponSettingdet.vue?vue&type=script&lang=js&"
import style0 from "./couponSettingdet.vue?vue&type=style&index=0&id=cae4812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae4812a",
  null
  
)

export default component.exports